import React, { useMemo } from 'react';

const StructuredData = React.forwardRef(({ children }, forwardedRef) => {
  const stringifiedChildren = useMemo(() => {
    switch (typeof children) {
      case 'function': {
        return JSON.stringify(children());
      }
      default: {
        return JSON.stringify(children);
      }
    }
  }, [children]);

  return (
    <script
      ref={forwardedRef}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: stringifiedChildren }}
    />
  );
});

StructuredData.displayName = 'StructuredData';

export default StructuredData;
